import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import PaymentModal from './PaymentModal';
import {
  mobileActionRow,
  mobileAddButton,
  mobileAmount,
  mobileCard,
  mobileCardHeader,
  mobileCardList,
  mobileCardTitle,
  mobileDeleteButton,
  mobileEditButton,
  mobileEmpty,
  mobileInfoGrid,
  mobileInfoItem,
  mobileInfoLabel,
  mobileInfoValue,
  mobileSubText,
  mobileTabWrap,
  mobileTitleText,
  mobileTopActionRow,
} from './ReservationDetail.mobileStyles';

const fmt = (value) => (value == null ? '-' : Number(value).toLocaleString('ko-KR'));
const fmtDate = (value) => (value ? String(value).slice(0, 10) : '-');
const paymentLabel = (value) => ({ cash: '현금', card: '카드' }[value] || '-');

export default function PaymentsTab({ payments = [], travelCode, onChanged, isMobile = false }) {
  const [modalRow, setModalRow] = useState(undefined);

  async function handleDelete(id) {
    if (!window.confirm('결제 내역을 삭제하시겠습니까?')) return;
    const res = await apiClient.delete(`/api/admin/reservation-payments/${id}`);
    if (res.ok && res.data?.success) onChanged && onChanged();
    else alert(res.data?.message || '삭제 실패');
  }

  return (
    <div style={isMobile ? mobileTabWrap : { display: 'grid', gap: 12 }}>
      <div style={isMobile ? mobileTopActionRow : { display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={() => setModalRow(null)} style={isMobile ? mobileAddButton : addBtn}>+ 결제 추가</button>
      </div>

      {payments.length === 0 ? (
        <div style={isMobile ? mobileEmpty : emptyStyle}>결제 내역 없음</div>
      ) : isMobile ? (
        <div style={mobileCardList}>
          {payments.map((payment, index) => (
            <div key={payment.id} style={mobileCard}>
              <div style={mobileCardHeader}>
                <div style={mobileCardTitle}>
                  <span style={mobileTitleText}>결제 #{index + 1} · {paymentLabel(payment.payment_method)}</span>
                  <span style={mobileSubText}>{fmtDate(payment.payment_date)}</span>
                </div>
                <span style={mobileAmount()}>{fmt(payment.amount)}</span>
              </div>
              <div style={mobileInfoGrid}>
                <Info label="지불일" value={fmtDate(payment.payment_date)} />
                <Info label="지불수단" value={paymentLabel(payment.payment_method)} />
                <Info label="현금영수증번호" value={payment.cash_receipt_issue_no || '-'} />
                <Info label="현금영수증금액" value={fmt(payment.cash_receipt_amount)} />
              </div>
              <div style={mobileActionRow}>
                <button onClick={() => setModalRow(payment)} style={mobileEditButton}>수정</button>
                <button onClick={() => handleDelete(payment.id)} style={mobileDeleteButton}>삭제</button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead style={{ background: 'var(--bg)', color: 'var(--text-muted)' }}>
              <tr>
                <th style={th}>지불일</th>
                <th style={{ ...th, textAlign: 'right' }}>고객지불</th>
                <th style={th}>지불수단</th>
                <th style={th}>현금영수증번호</th>
                <th style={{ ...th, textAlign: 'right' }}>현금영수증금액</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment.id} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={td}>{fmtDate(payment.payment_date)}</td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{fmt(payment.amount)}</td>
                  <td style={td}>{paymentLabel(payment.payment_method)}</td>
                  <td style={td}>{payment.cash_receipt_issue_no || '-'}</td>
                  <td style={{ ...td, textAlign: 'right' }}>{fmt(payment.cash_receipt_amount)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => setModalRow(payment)} style={editBtn}>수정</button>{' '}
                    <button onClick={() => handleDelete(payment.id)} style={delBtn}>삭제</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modalRow !== undefined && (
        <PaymentModal
          travelCode={travelCode}
          row={modalRow}
          onClose={() => setModalRow(undefined)}
          onSaved={() => onChanged && onChanged()}
        />
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div style={mobileInfoItem}>
      <span style={mobileInfoLabel}>{label}</span>
      <span style={mobileInfoValue}>{value}</span>
    </div>
  );
}

const th = { padding: '8px 10px', textAlign: 'left', fontWeight: 600, fontSize: 11 };
const td = { padding: '6px 10px', color: 'var(--text)' };
const emptyStyle = { padding: 16, color: 'var(--text-muted)', textAlign: 'center', fontSize: 12 };
const addBtn = { padding: '4px 12px', background: 'var(--accent-700, #7c3aed)', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11, fontWeight: 600 };
const editBtn = { padding: '2px 8px', background: 'transparent', color: 'var(--accent-300, #a78bfa)', border: '1px solid var(--accent-700, #7c3aed)', borderRadius: 4, cursor: 'pointer', fontSize: 10 };
const delBtn = { padding: '2px 8px', background: 'transparent', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 4, cursor: 'pointer', fontSize: 10 };
